import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "md:max-w-7xl mx-auto flex flex-wrap items-center px-4 py-3 gap-y-2" }
const _hoisted_2 = ["alt"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "ml-3 pl-3 border-l border-white border-opacity-30 text-white text-lg sm:text-xl font-light tracking-wide" }, " Agenda ", -1)
const _hoisted_4 = { class: "w-full md:w-auto md:ml-8 flex flex-col md:flex-row md:items-center gap-1 md:gap-2 mt-2 md:mt-0" }

import { branding } from "@/branding";
import { getThemeColor } from "@/branding";
import store from "@/store";
import { computed } from "vue";
import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'NavBar',
  setup(__props) {

const theme = getThemeColor();
const route = useRoute();
const logoUrl = `${process.env.BASE_URL}img/moinho-globo-logo-white.png`;

const isActive = (name: string) => route.name === name;

const usuario_trigo_produtor = computed(
  () => store.state.acessos.usuario_trigo_produtor
);

const logout = () => {
  store.dispatch("logout");
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(["shadow-md", `bg-${_unref(theme)}-800`])
  }, [
    _createElementVNode("nav", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: {
          name: _unref(usuario_trigo_produtor) ? 'MotoristasPlacas' : 'Home',
        },
        class: "flex items-center hover:opacity-90 transition-opacity duration-200"
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: logoUrl,
            alt: _unref(branding).brandName,
            class: "h-9 sm:h-10 w-auto"
          }, null, 8, _hoisted_2),
          _hoisted_3
        ]),
        _: 1
      }, 8, ["to"]),
      _createElementVNode("div", _hoisted_4, [
        (!_unref(usuario_trigo_produtor))
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: { name: 'AgendamentoAgendar' },
              class: _normalizeClass(["px-3 py-2 rounded-lg text-base font-medium text-white transition-colors duration-150", isActive('AgendamentoAgendar') ? `bg-${_unref(theme)}-900` : `hover:bg-${_unref(theme)}-700`])
            }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  icon: "calendar",
                  class: "mr-2"
                }),
                _createTextVNode(" Agendar ")
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true),
        (!_unref(usuario_trigo_produtor))
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 1,
              to: { name: 'AgendamentoMeus' },
              class: _normalizeClass(["px-3 py-2 rounded-lg text-base font-medium text-white transition-colors duration-150", isActive('AgendamentoMeus') ? `bg-${_unref(theme)}-900` : `hover:bg-${_unref(theme)}-700`])
            }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  icon: "list",
                  class: "mr-2"
                }),
                _createTextVNode(" Meus Agendamentos ")
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true),
        (_unref(usuario_trigo_produtor))
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 2,
              to: { name: 'MotoristasPlacas' },
              class: _normalizeClass(["px-3 py-2 rounded-lg text-base font-medium text-white transition-colors duration-150", isActive('MotoristasPlacas') ? `bg-${_unref(theme)}-900` : `hover:bg-${_unref(theme)}-700`])
            }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  icon: "users",
                  class: "mr-2"
                }),
                _createTextVNode(" Motoristas/Placas ")
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "w-full md:w-auto md:ml-auto px-3 py-2 rounded-lg text-left md:text-center text-base font-medium text-white hover:bg-red-600 transition-colors duration-150 cursor-pointer",
        onClick: logout
      }, [
        _createVNode(_component_font_awesome_icon, {
          icon: "sign-out-alt",
          class: "mr-2"
        }),
        _createTextVNode(" Sair ")
      ])
    ])
  ], 2))
}
}

})